(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('BlockedPhoneExtReceive', BlockedPhoneExtReceive)
        .factory('BlockedPhoneExtUpload', BlockedPhoneExtUpload);

    BlockedPhoneExtReceive.$inject = ['$resource'];

    function BlockedPhoneExtReceive ($resource) {
        var resourceUrl =  'api/blocked-phones/receive-new/:id';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET'}
        });
    }

    BlockedPhoneExtUpload.$inject = ['$resource'];

    function BlockedPhoneExtUpload ($resource) {
        var resourceUrl =  'api/blocked-phones/upload-all/:id';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET'}
        });
    }
})();
